export default import.meta.ROLLDOWN_FILE_URL_9VYtY6v7unzzTZbBqcLtSQ